export const FIREBASE_INFO =  {
    apiKey: "AIzaSyACmTKjpBZWUZIhMbQD1ZkcgKsBi4hzGM4",
    authDomain: "mealmate-ad158.firebaseapp.com",
    databaseURL: "https://mealmate-ad158.firebaseio.com",
    projectId: "mealmate-ad158",
    storageBucket: "mealmate-ad158.appspot.com",
    messagingSenderId: "680295001958"
  };






// WEBPACK FOOTER //
// ./src/app/firebase.info.ts